module.exports = __webpack_public_path__ + "media/images/product_movie-c34489a4ee8b29b7afaa013afa04fe50.png";